import React from 'react';
import { Page } from '../Common/Components/Page';
import { SystemStatusContent } from './Components/SystemStatusContent';

export const SystemStatus = (): React.JSX.Element => (
  <Page title="System-Status" accessKey={'appliances'} isSearchable={false}>
    <SystemStatusContent />
  </Page>
);
